// extracted by mini-css-extract-plugin
module.exports = {"locked__user--container":"LockedUserMessage_locked__user--container__RFb4Z","icon":"LockedUserMessage_icon__UhXwz"};